export default "__VITE_ASSET__BEPwZeww__"